import React from 'react';

import isEmpty from 'lodash/isEmpty';

import { Section } from '@gogame/components';
import { withFormFieldGroupFormField } from '@gogame/form';

import { AFFILIATES } from 'scenes/SmartRules/SmartRuleForm/AdvertisingPopulation';
import {
  GENERAL,
  AFFECTED_LEVEL,
  SECONDARY_AFFECTED_LEVEL,
} from 'scenes/SmartRules/SmartRuleForm/General';
import { ADVERTISING_TARGET } from 'scenes/SmartRules/SmartRuleForm/constants';
import { loadModifyActions } from 'scenes/SmartRules/sources/fields';

import { ConditionField } from './ConditionField';
import { ModifyActionFields } from './ModifyAction';
import { modifyActionSchema } from './schemas';

const loadModifyActionsWithDepends = ({
  [AFFECTED_LEVEL]: affectedLevel,
  [SECONDARY_AFFECTED_LEVEL]: secondaryAffectedLevel,
  [AFFILIATES]: affiliates,
}) => {
  return affectedLevel && !isEmpty(affiliates)
    ? loadModifyActions({
        [AFFECTED_LEVEL]: affectedLevel,
        [SECONDARY_AFFECTED_LEVEL]: secondaryAffectedLevel,
        affiliates,
      }).then((data) => !isEmpty(data))
    : false;
};

export const ModifyActionSection = withFormFieldGroupFormField({
  validationSchema: modifyActionSchema,
})(({ name, value, formik, isEdit }) => {
  return (
    <ConditionField
      name={`${name}.show`}
      when={loadModifyActionsWithDepends}
      depends={[
        `${GENERAL}.${AFFECTED_LEVEL}`,
        `${GENERAL}.${SECONDARY_AFFECTED_LEVEL}`,
        `${ADVERTISING_TARGET}.${AFFILIATES}`,
      ]}
    >
      <Section title={'Modify Action'}>
        <ModifyActionFields
          name={name}
          value={value}
          hierarchyState={formik.hierarchyState}
          setFieldValue={formik.setFieldValue}
          isEdit={isEdit}
        />
      </Section>
    </ConditionField>
  );
});
